import { memo, useMemo, useState } from 'react';
import { STICKER_PACKS, Sticker } from '../stickers';

// Bộ emoji Unicode (miễn phí, hiển thị sẵn trên mọi máy) — thay cho bộ có bản quyền.
const GROUPS = [
  {
    key: 'smileys', label: '😀', name: 'Cảm xúc',
    list: '😀 😃 😄 😁 😆 😅 😂 🤣 🥲 ☺️ 😊 😇 🙂 🙃 😉 😌 😍 🥰 😘 😗 😚 😋 😛 😝 😜 🤪 🤨 🧐 🤓 😎 🥳 🤩 😏 😒 😞 😔 😟 🙁 ☹️ 😣 😖 😫 😩 🥺 😢 😭 😤 😠 😡 🤬 🤯 😳 🥵 🥶 😱 😨 😰 😥 😓 🤔 🤭 🤫 😶 😐 😑 😬 🙄 😮 😲 🥱 😴 🤤 😪 🤐 🥴 🤢 🤮 🤧 😷 🤒 🤕'.split(' '),
  },
  {
    key: 'gestures', label: '👍', name: 'Cử chỉ',
    list: '👍 👎 👌 ✌️ 🤞 🤟 🤘 🤙 👈 👉 👆 👇 ☝️ ✋ 🤚 🖐️ 🖖 👋 🤝 👏 🙌 👐 🙏 ✍️ 💪 🦾 👀 👁️ 🫶 🤲 🫰 🤌'.split(' '),
  },
  {
    key: 'hearts', label: '❤️', name: 'Tình cảm',
    list: '❤️ 🧡 💛 💚 💙 💜 🖤 🤍 🤎 💔 ❣️ 💕 💞 💓 💗 💖 💘 💝 💟 💋 💌'.split(' '),
  },
  {
    key: 'animals', label: '🐶', name: 'Động vật',
    list: '🐶 🐱 🐭 🐹 🐰 🦊 🐻 🐼 🐨 🐯 🦁 🐮 🐷 🐸 🐵 🐔 🐧 🐦 🐤 🦄 🐝 🦋 🐌 🐢 🐙 🦀 🐬 🐳 🐠 🐟'.split(' '),
  },
  {
    key: 'food', label: '🍔', name: 'Đồ ăn',
    list: '🍎 🍐 🍊 🍋 🍌 🍉 🍇 🍓 🍒 🍑 🥭 🍍 🥥 🥝 🍅 🥑 🍔 🍟 🍕 🌭 🍿 🍜 🍲 🍣 🍱 🍰 🎂 🍦 🍩 🍪 ☕ 🍺 🍻 🥂 🍷'.split(' '),
  },
  {
    key: 'activity', label: '⚽', name: 'Hoạt động',
    list: '⚽ 🏀 🏈 ⚾ 🎾 🏐 🏓 🏸 🎯 🎮 🎲 🎸 🎺 🎉 🎊 🎁 🏆 🥇 🥈 🥉 🔥 ✨ ⭐ 🌟 💯 💢 💥 💫 💦 💨'.split(' '),
  },
  {
    key: 'objects', label: '💡', name: 'Khác',
    list: '💡 📌 📎 ✅ ❌ ❗ ❓ ⚠️ 🔔 ⏰ 📅 📞 💬 💭 📊 📈 💰 💵 🚀 🌈 ☀️ 🌙 ❄️ ☔ 👑 💎'.split(' '),
  },
];

const RECENT_KEY = 'ft-emoji-recent';
function getRecent() {
  try {
    return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
  } catch {
    return [];
  }
}

function EmojiPicker({ onPick, onSend }) {
  const [mode, setMode] = useState('emoji'); // 'sticker' | 'emoji'
  const [tab, setTab] = useState('recent');
  const [pack, setPack] = useState(STICKER_PACKS[0].key); // bộ sticker đang xem
  const recent = useMemo(getRecent, []);

  function pickEmoji(e) {
    const next = [e, ...getRecent().filter((x) => x !== e)].slice(0, 16);
    localStorage.setItem(RECENT_KEY, JSON.stringify(next));
    onPick(e);
  }

  const tabs = recent.length ? [{ key: 'recent', label: '🕘' }, ...GROUPS] : GROUPS;
  const list =
    tab === 'recent'
      ? (recent.length ? recent : GROUPS[0].list)
      : (GROUPS.find((g) => g.key === tab) || GROUPS[0]).list;
  const curPack = STICKER_PACKS.find((p) => p.key === pack) || STICKER_PACKS[0];

  return (
    <div className="emoji-pop" onMouseDown={(e) => e.preventDefault()}>
      <div className="emoji-modes">
        <button type="button" className={'emoji-mode' + (mode === 'sticker' ? ' active' : '')} onClick={() => setMode('sticker')}>
          STICKER
        </button>
        <button type="button" className={'emoji-mode' + (mode === 'emoji' ? ' active' : '')} onClick={() => setMode('emoji')}>
          EMOJI
        </button>
      </div>

      {mode === 'emoji' && (
        <div className="emoji-tabs">
          {tabs.map((t) => (
            <button type="button" key={t.key} className={'emoji-tab' + (tab === t.key ? ' active' : '')} onClick={() => setTab(t.key)} title={t.name || 'Gần đây'}>
              {t.label}
            </button>
          ))}
        </div>
      )}

      {mode === 'sticker' && (
        <div className="emoji-tabs">
          {STICKER_PACKS.map((p) => (
            <button type="button" key={p.key} className={'emoji-tab' + (pack === p.key ? ' active' : '')} onClick={() => setPack(p.key)} title={p.name}>
              {p.label}
            </button>
          ))}
        </div>
      )}

      {mode === 'sticker' ? (
        <div className="emoji-grid sticker">
          {curPack.items.map((s) => (
            <button type="button" key={s.id} className="sticker-cell" onClick={() => onSend(s.id)} title={'Gửi: ' + s.text}>
              <Sticker id={s.id} size="sm" />
            </button>
          ))}
        </div>
      ) : (
        <div className="emoji-grid">
          {list.map((e, i) => (
            <button type="button" key={i} className="emoji-cell" onClick={() => pickEmoji(e)}>
              {e}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default memo(EmojiPicker);
